import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    minWidth: '400px',
    padding: '24px 32px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    background: '#fff',
    boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px',
  },
  containerDetailsUnit: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '6px',
  },
  containerTypeDetails: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  containerFromTO: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '6px',
  },
  typePriceTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    lineHeight: '20px',
  },
  fromToTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    lineHeight: '24px',
  },
  containerUnitModelsView: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  tableWrapper: {
    width: '100%',
  },
  SelectorContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  titleUnitType: {
    color: theme.palette.text.secondary,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
  unitTypeContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  unitTypeItem: {
    display: 'flex',
    padding: '4px 6px 4px 10px',
    alignItems: 'center',
    gap: '2px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid #D0D5DD',
    background: '#FFF',
    boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
  },
  unitType: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  },
  closeIcon: {
    cursor: 'pointer',
    display: 'flex',
    padding: '2px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addUnitType: {
    display: 'flex',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    border: '1px solid #D0D5DD',
    background: '#FFF',
    boxShadow:
      '0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 4px rgba(152, 162, 179, 0.14)',
  },
  textBtn: {
    color: theme.palette.text.tertiary,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
  },
}));
